import Error404Page from "@/app/pages/errors/404";
import React from "react";
import { useSearchParams } from "react-router-dom";
import BuilderIOSymbol from "./builderIOSymbol";

const BuilderIOSymbolPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");

  if (!page) {
    return <Error404Page />;
  }

  return <BuilderIOSymbol currentPath={page} />;
};

export default BuilderIOSymbolPage;
